import { nullish, number, object, record, string, unknown } from "valibot";

/**
 * Loose wire-shape for milestone rewards from socket/admin (avoid strict unions /
 * {@link FrameName} enum mismatches breaking save/overview parsing).
 */
const MilestoneRewardWireSchema = record(string(), unknown());

export const EventMilestoneRewardValidationSchema = MilestoneRewardWireSchema;

export const EventMilestoneValidationSchema = object({
	requiredSum: number(),
	reward: MilestoneRewardWireSchema,
	premium: nullish(
		object({
			reward: MilestoneRewardWireSchema,
		}),
	),
});
